import { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import genImg from "../images/gen.png";

function RemedialEducation() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="page-header text-center text-white">
        <div className="container">
          <h1 className="fw-bold" data-aos="fade-down">Remedial Education</h1>
          <p className="text-white-50 mt-2" data-aos="fade-up">Certificate Program · 6 Months</p>
        </div>
      </section>

      <section className="py-5">
        <div className="container text-center" data-aos="zoom-in">
          <img src={genImg} alt="Remedial Education" className="img-fluid rounded-4 shadow" style={{ maxWidth: "600px", width: "100%" }} />
        </div>

        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-lg-8" data-aos="fade-up">
              <h3 className="fw-bold mb-3">About This Program</h3>
              <p className="text-muted">Specialized teaching methods to help struggling learners succeed. Master diagnostic assessment, individualized instruction, and adaptive learning technologies.</p>

              <div className="row g-3 mt-3">
                {["Diagnostic Assessment", "IEP Development", "Adaptive Tech", "Student Psychology", "Inclusive Education", "Learning Disabilities"].map((h, i) => (
                  <div className="col-6 col-md-4" key={i}>
                    <div className="highlight-tag d-block text-center py-2">{h}</div>
                  </div>
                ))}
              </div>

              <div className="d-flex gap-3 mt-4 flex-wrap">
                <Link to="/contact" className="btn btn-enroll">
                  <i className="bi bi-send me-2"></i>Enquire Now
                </Link>
                <Link to="/courses" className="btn btn-outline-custom">
                  <i className="bi bi-arrow-left me-2"></i>Back to Courses
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default RemedialEducation;
